import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditSeriesComponent } from './addEditSeries.component';

//import * as fromCommonStore from '../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { seriesModel } from '../../../model/index';
import { SeriesService } from '../../../services/index';

@Component({
    selector: 'series-tab',
    templateUrl: './series.component.html',
})
export class seriesMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public seriesdata: any[] = [];

    isLoadMask: Promise<any>;
    // seriesdata: seriesModel[];
    isLoading: boolean = false;

    constructor(public store: Store<fromRootStore.State>, private seriesService: SeriesService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'series_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'SERIES NAME', prop: 'series_name', width: 250, minWidth: 250, maxWidth: 250 },
            { name: 'Brand', prop: 'brand_name', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 70, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getSeriesList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getSeriesList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSeriesList();
    }

    getSeriesList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.seriesService
            .getSeriesList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.seriesdata = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditSeries(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditSeriesComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Series Details';
        this.bsModalRef.content.seriesdata = Object.assign({}, row);
        this.bsModalRef.content.seriesLoadEvent.subscribe(($e) => {
            that.getSeriesList();
        });
    }


    onDeleteSeries(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Series: ' + row.series_name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.seriesService
                .deleteSeries(row.series_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getSeriesList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/series/series.component.ts